import React from 'react';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Topbar from '../topbar/Topbar';
import Buttom from '../Bottom/Bottom';
import './feedback.css';
import axiosInstance from '../../config';
import { useRef, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import SocialContext from '../../context/SocialContext';
import Alertjs from '../../components/alert/Alert';

export default function Feedback() {
  const { user: currentuser, setshowalert, setalertmessage, setalertType, showalert } = useContext(SocialContext)
  const [value, setValue] = React.useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    window.document.title = 'SocialHub - Feedback';
  }, [])


  const desc = useRef();
  const name = useRef();

  const feedbacksubmitfun = async (event) => {
    event.preventDefault();
    if (value != 0) {
      try {
        const feedback = {
          'name': window.localStorage.getItem('currentUID') ? currentuser.username : name.current.value,
          'ratting': value,
          'feedback': desc.current.value,
          'uid': window.localStorage.getItem('currentUID') ? window.localStorage.getItem('currentUID') : '',
        }
        const res = await axiosInstance.post("/api/auth/feedback", feedback);
        if (res.data.success) {
          setValue(0);
          setshowalert(true);
          setalertType('success');
          setalertmessage("Thankyou for your feedback");
          setTimeout(() => {
            setshowalert(false);
            navigate('/');
          }, 2000);
        }
      } catch (error) {
        console.log('feedback error', error);
      }
    } else {
      setshowalert(true);
      setalertType('warning');
      setalertmessage("Please give ratting and try again");
      setTimeout(() => {
        setshowalert(false);
      }, 2000);
    }
  }

  return (
    <>
      <Topbar />
      {showalert ? <div style={{ 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
        <Alertjs />
      </div> : ""}
      
      <div className="back">
        <div className="feedbackpage">
          <form className="feedbackConteiner" onSubmit={feedbacksubmitfun}>
            {!currentuser.username && (<div className="emailDiv">
              <p>Enter your Name</p>
              <input type="text" ref={name} placeholder="Name" required />
            </div>)}
            <h3>Your overall satisfactioion of this website is</h3>
            <Box className='box' sx={{ '& > legend': { mt: 3 }, }}>
              <Rating size="large" required name="simple-controlled" value={value} onChange={(event, newValue) => { setValue(newValue); }} />
            </Box>
            <p style={{ margin: '5px auto', textAlign: 'center', 'fontFamily': 'sans-serif' }}>Please leave your Feedback or Suggestion below</p>
            <textarea cols="30" rows="4" ref={desc} placeholder='Write something here...'></textarea>
            <button className='formbutton signup-btn'>Submit</button>
            <p style={{ 'marginTop': '8px' }}>Renurn to home screen? <Link style={{ 'textDecoration': 'none' }} to={'/'}>Skip</Link></p>
            <hr />
          </form>
        </div>
        </div>
      <Buttom />
    </>
  );
}
